import React from "react";
import "./allVersions.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import SliderVersion from "../../component/shared/sliderVersion/SliderVersion.js";
import Dropdown from "../../component/shared/dropdown/Dropdown.js";
import { FormattedMessage, useIntl } from "react-intl";
import Publication from "component/shared/publication/Publication";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import Paginator from "component/shared/Paginator/Paginator";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

function AllVersions() {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

      
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/publications", title: "Publications Page" });
  }, []);


  const publicationTypes = useSWR({
    url: END_POINTS.PUBLICATION_TYPE,
  });
  const periodicsFetching = useSWR({
    url: END_POINTS.PERIODICS,
  });
  const subjectsFetching = useSWR({
    // url: END_POINTS.SUB_SUBJECTS,
    url: END_POINTS.SUBJECTS,
  });

  const subjectRendering = (title, translations) => {
    const subject = LabelLangString({
      id: "title",
      currentLocale: currentLocale,
      defaultValue: title,
      translations: translations,
    });
    return subject;
  };

  const renderDataCard = () => {
    const subjectData =
      subjectsFetching.error ||
      subjectsFetching.isLoading ||
      subjectsFetching.data === undefined
        ? []
        : subjectsFetching.data.data;
    const rendering =
      Object.keys(subjectData).length > 0 ? (
        <>
          {subjectData.map(({ title, subSubjects, subjectTranslations }, i) => (
            <optgroup
              key={i}
              label={subjectRendering(title, subjectTranslations)}
            >
              {subSubjects?.map(({ title, subjectTranslations, id }, i) => (
                <option
                  key={i}
                  value={id}
                  title={LabelLangString({
                    id: "title",
                    currentLocale: currentLocale,
                    defaultValue: title,
                    translations: subjectTranslations,
                  })}
                >
                  <LabelLang
                    id={"title"}
                    defaultValue={title}
                    translations={subjectTranslations}
                  />
                </option>
              ))}
            </optgroup>
          ))}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  const defaultState = {
    keyWord: null,
    PublicationTypeId: null,
    SubjectId: null,
    PeriodicId: null,
    StartDate: null,
    EndDate: null,
    PageSize: 5,
    CurrentPage: 1,
  };

  const [filters, setFilters] = React.useState(defaultState);
  const [changeState, setChangeState] = React.useState(defaultState);

  const handelFilterData = (e) => {
    let filterData = { ...changeState };
    filterData[e.target.name] = +e.target.value !== 0 ? e.target.value : null;
    setChangeState(filterData);
  };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      CurrentPage: value,
    }));
  };

  const publicationsFetching = useSWR({
    url: END_POINTS.PUBLICATIONS,
    params: filters,
  });

  const renderVersions = () => {
    const versions =
      publicationsFetching.error ||
      publicationsFetching.isLoading ||
      publicationsFetching.data === undefined ||
      publicationsFetching.data === null
        ? []
        : publicationsFetching.data.data;

    const rendering =
      Object.keys(versions).length > 0 ? (
        <Paginator
          size={filters.PageSize}
          children={versions}
          change={onPageIndexChange}
          page={filters.CurrentPage}
          totalCount={publicationsFetching?.data?.page?.totalCount}
        >
          {versions.map((item, i) => (
            <Publication key={i} item={item} />
          ))}
        </Paginator>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  return (
    <>
      <div>
        <InnerHeader
          breadcrumb={[
            {
              title: <FormattedMessage id="publications" />,
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "browse-publications" })}
        />
        <div className="browsetopic-box alls mt-0">
          <div className="container">
            <form
              className="row gy-3"
              onSubmit={(e) => {
                e.preventDefault();
                setFilters({ ...changeState });
              }}
            >
              <div className="col-12 col-lg-8 ">
                <div className="item-form coll">
                  <label htmlFor="keyWord">
                    <FormattedMessage id="search-by-word" />{" "}
                  </label>
                  <input
                    name="keyWord"
                    id="keyWord"
                    onChange={handelFilterData}
                    type="search"
                    className=" form-control"
                    placeholder={intl.formatMessage({ id: "search" })}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="PublicationTypeId">
                    <FormattedMessage id="publication-type" />
                  </label>
                </div>
                <Dropdown
                  item={publicationTypes?.data?.data}
                  name={"PublicationTypeId"}
                  placeholder={intl.formatMessage({ id: "all" })}
                  change={handelFilterData}
                />
              </div>
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="SubjectId">
                    <FormattedMessage id="topic" />
                  </label>
                </div>
                {/* <Dropdown
                  item={subjectsFetching?.data?.data}
                  name="SubjectId"
                  // placeholder={intl.formatMessage({ id: "choose-topic" })}
                  placeholder={intl.formatMessage({ id: "all" })}
                  change={handelFilterData}
                /> */}
                <div className="dropdown">
                  <select
                    className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                    name="SubjectId"
                    id="SubjectId"
                    onChange={handelFilterData}
                  >
                    <option value={""}>{<FormattedMessage id="all" />}</option>
                    {renderDataCard()}
                  </select>
                  <div className="dropdown-icon" />
                </div>
              </div>
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="PeriodicId">
                    <FormattedMessage id="periodical" />
                  </label>
                </div>
                <Dropdown
                  item={periodicsFetching?.data?.data}
                  name="PeriodicId"
                  // placeholder={intl.formatMessage({ id: "choose-periodical" })}
                  placeholder={intl.formatMessage({ id: "all" })}
                  change={handelFilterData}
                />
              </div>
              <div className="col-12 col-lg-4 "></div>
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="StartDate">
                    <FormattedMessage id="version-date" /> &nbsp;
                    <FormattedMessage id="fromX" />:
                  </label>
                  <input
                    name="StartDate"
                    id="StartDate"
                    onChange={handelFilterData}
                    type="date"
                    style={{textAlign: dir === 'rtl' ? 'end' : 'start'}}
                    className="form-control position-relative"
                  />
                </div>
              </div>
              <div className="col-12 col-lg-4 ">
                <div className="item-form coll">
                  <label htmlFor="EndDate">
                    <FormattedMessage id="toX" />:
                  </label>
                  <input
                    name="EndDate"
                    id="EndDate"
                    onChange={handelFilterData}
                    type="date"
                    style={{textAlign: dir === 'rtl' ? 'end' : 'start'}}
                    className="form-control position-relative"
                  />
                </div>
              </div>
              <div className="col-12 col-lg-4 ">
                <div className="row-r mt-5  mb-3">
                  <button type="submit" className="main-btn">
                    <span>
                      <FormattedMessage id="search-publications" />
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <ContentLoading
          isLoading={
            // publicationsFetching.error ||
            publicationsFetching.isLoading
          }
        >
          <div className="browsetopic">
            {/* <div className="container">
              <div className="row">
                <div className="col-12"></div>
              </div>
            </div> */}
            <div className="container">
              <div className="row">{renderVersions()}</div>
            </div>
          </div>
        </ContentLoading>
      </div>
      <div className="all-vv back-vv">
        <SliderVersion />
      </div>
    </>
  );
}

export default AllVersions;
